import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M3.333 4.157A.75.75 0 0 1 4 3.75h16a.75.75 0 0 1 .613 1.183l-5.863 8.305V21a.75.75 0 0 1-1.055.685l-4-1.777a.75.75 0 0 1-.445-.686V13.15L3.39 4.936a.75.75 0 0 1-.057-.78M5.457 5.25l5.154 7.223c.09.127.139.28.139.436v5.826l2.5 1.11V13a.75.75 0 0 1 .137-.432l5.166-7.318z",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }